import { controller, rolesObj } from '../controller'
import { localStorageService } from '../../helpers'
export const pageCompanyProfileController = () => {
  const roles = localStorageService.getUserData()
  const obj = controller().checkRole(roles)
  return {
    asset: () => {
      const { roleSingle, roles } = obj
      if (roles) {
        const systemadmin = controller().filterRole(
          roles,
          res => res.id === rolesObj.systemadmin
        )
        const admin = controller().filterRole(
          roles,
          res => res.id === rolesObj.admin
        )
        const user = controller().filterRole(
          roles,
          res => res.id === rolesObj.user
        )
        const risk = controller().filterRole(
          roles,
          res => res.id === rolesObj.risk
        )
        const purchaser = controller().filterRole(
          roles,
          res => res.id === rolesObj.purchaser
        )
        const tec = controller().filterRole(
          roles,
          res => res.id === rolesObj.tec
        )
        const approver = controller().filterRole(
          roles,
          res => res.id === rolesObj.approver
        )
        const observer = controller().filterRole(
          roles,
          res => res.id === rolesObj.observer
        )
        if (roleSingle) {
          if (systemadmin.length !== 0) {
            return true
          } else if (admin.length !== 0) {
            return true
          } else if (user.length !== 0) {
            return false
          } else if (risk.length !== 0) {
            return false
          } else if (purchaser.length !== 0) {
            return false
          } else if (tec.length !== 0) {
            return false
          } else if (approver.length !== 0) {
            return false
          } else if (observer.length !== 0) {
            return false
          }
        } else {
          if (systemadmin.length !== 0 || admin.length !== 0) {
            return true
          } else {
            return false
          }
        }
      } else {
        return false
      }
    },
    getMultiRole: () => {
      const { roleSingle, roles } = obj
      if (!roleSingle) {
        return roles
      }
    },
  }
}
